import type { FC } from 'react';

import { DialogCloseButton } from '@wwe-portal/ui/components/dialog';

import { RosterDialog } from './roster-dialog';
import type { RosterFuseUpProps } from './roster-fuse-up';
import { RosterFuseUp } from './roster-fuse-up';

export interface RosterRecruitmentDialogProps {
  open: boolean;
  onClose?: () => void;
  contentProps: Omit<
    RosterFuseUpProps,
    | 'onSelectLevel'
    | 'onSelectStar'
    | 'selectedStar'
    | 'selectedLevel'
    | 'isUpgradeMode'
  >;
}
export const RosterRecruitmentDialog: FC<RosterRecruitmentDialogProps> = ({
  open,
  onClose,
  contentProps,
}) => {
  return (
    <RosterDialog
      dataId="roster-recruitment-dialog"
      onClose={onClose}
      open={open}
    >
      <RosterFuseUp
        isUpgradeMode={false}
        {...contentProps}
        className={contentProps.className}
      />
      <DialogCloseButton onClose={onClose} />
    </RosterDialog>
  );
};
